<template>
	<div>
		<div v-for="room in items" :key="room.ID" class="room row contentblock">
			<div class="columns column6 col-image">
				<div v-if="room.images.length">
					<a
						:data-src="room.images[0].image"
						:data-fancybox="`gallery-${room.ID}`"
						:data-caption="room.images[0].imageAlt"
						:title="room.images[0].imageAlt"
					>
						<div v-if="room.images.slice(1).length" class="more-images" title="More images">
							<font-awesome-icon class="icon" icon="fal fa-images" size="1x" />
						</div>
						<picture>
							<source
								v-if="room.images[0].imageWebp"
								:srcset="room.images[0].imageWebp"
								type="image/webp"
							/>
							<source :srcset="room.images[0].image" />
							<img :src="room.images[0].image" :alt="room.images[0].imageAlt" loading="lazy" />
						</picture>
					</a>
				</div>
				<div v-if="room.images.slice(1).length" class="thumbnails">
					<a
						v-for="item in room.images.slice(1)"
						:key="item.image"
						:data-src="item.image"
						:data-fancybox="`gallery-${room.ID}`"
						:data-caption="item.imageAlt"
						:title="item.imageAlt"
					>
						<picture>
							<source v-if="item.imagesWebp" :srcset="item.imagesWebp[1]" type="image/webp" />
							<source :srcset="item.images[1]" />
							<img :src="item.images[1]" />
						</picture>
					</a>
				</div>
			</div>
			<div class="columns column6 col-content">
				<div class="contentblock-content">
					<h3>{{ room.header }}</h3>
					<div class="room-icon">
						<div v-if="room.pax">
							<font-awesome-icon :icon="`fas fa-users`" size="1x" />
							<span>{{ room.pax }}</span>
						</div>
						<div v-if="room.surface">
							<font-awesome-icon :icon="`fas fa-ruler-combined`" size="1x" />
							<span>{{ room.surface }}</span>
						</div>
					</div>
					<div v-parse-links v-html="room.content" />
					<book-button v-if="type === 'rooms'" class="button cta">
						{{ $t('bookThisRoom') }}
					</book-button>
					<nuxt-link v-else :to="localePath('meeting-form', locale)" class="button cta">
						{{ $t('buttonRequestInfo') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { locale } = useI18n();
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
	type: { type: String, default: 'rooms' },
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>

<style lang="scss" scoped>
.contentblock {
	display: flex;
	flex-flow: row-reverse wrap;
	align-items: stretch;
	padding: 0;
	margin: 1% auto;
	position: relative;
	gap: 1%;

	&:nth-child(odd) {
		flex-direction: row;

		.col-image {
			left: 0;
			right: auto;
		}
	}

	.columns {
		width: 49.5%;
		padding: 0;
		display: flex;
		flex-wrap: wrap;
		align-items: stretch;
	}

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.col-content {
		position: relative;
		z-index: 2;
	}

	.col-image {
		position: relative;
		cursor: pointer;

		div {
			width: 100%;
		}
	}

	.contentblock-content {
		padding: 80px 50px;
		background: var(--secondary-background-color);
		display: flex;
		flex-wrap: wrap;
		align-items: center;
	}
}

.thumbnails {
	display: none;
}

.more-images {
	position: absolute;
	left: 30px;
	bottom: 20px;
	font-size: 38px;
	cursor: pointer;
	z-index: 3;
	transition: all 0.3s ease-in-out;
	width: auto !important;
	color: #fff;

	&:hover {
		transform: scale(1.1);
		color: #fff;
	}
}

.room-icon {
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: center;
	margin: 0 0 8px;
	width: 100%;
	font-size: 16px;

	div {
		margin: 5px 22px 5px 0;
	}

	svg {
		font-size: 16px;
		margin: 0 8px 0 0;
	}
}

@media (max-width: 1080px) {
	.contentblock {
		.col-image {
			width: 100%;
			position: relative;
		}

		.col-content {
			padding: 0;
			width: 100%;
			margin: 10px auto;
		}

		.contentblock-content {
			padding: 50px;
		}
	}
}

@media (max-width: 580px) {
	.contentblock {
		margin-bottom: 25px;

		.contentblock-content {
			padding: 35px;
		}
	}
}
</style>
